<template>
    <section class='hero is-theme is-fullheight'>
        <button class='button is-light howto-button' @click='showHelp'>
            <span class='icon'>
                <i class='far fa-question-circle'></i>
            </span>
            <span>使い方</span>
        </button>
        <button class='button is-light open-button' @click="present" v-if='condition === "select"'>
            <span class='icon'>
                <i class="fas fa-user-friends"></i>
            </span>
            <span>結果発表</span>
        </button>
        <div class='hero-body'>
            <div class='container has-text-centered'>
                <div class='column is-6 is-offset-3'>
                    <span class='groupName'>チュートリアル合コン</span><br>
                    <!-- @は子→親で参照するメソッド -->
                    <Select v-if = 'condition==="select"' @setEntry = 'setEntry'/>
                    <Result v-if = 'condition==="result"' :matched = 'matched'/>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Select from '@/views/Trial/Select.vue'
import Result from '@/views/Trial/Result.vue'
import Help from '@/views/Page/Dialog/Help.vue'

export default {
    components: {Select, Result},
    data(){
        return{
            condition: 'select',
            entries: [],
            isFirst: 0,
            isSecond: 0,
            isThird: 0,
            matched: '',
        }
    },
    methods:{
        showHelp: function(id, name){
            this.$modal.open({
                parent: this,
                component: Help,
            });
        },
        present: function(){
            this.condition = 'result';
        },
        setEntry: function(e,s1,s2,s3){
            this.entries = e;
            this.isFirst = s1||0;
            this.isSecond = s2||0;
            this.isThird = s3||0;
            let matchingNum = [1,2,5,6,8,9,10,11];
            if(matchingNum.includes(parseInt(this.isThird,10))){
                this.matched = this.entries[this.isThird - 1][this.isThird.toString()];
            }
            if(matchingNum.includes(parseInt(this.isSecond,10))){
                this.matched = this.entries[this.isSecond - 1][this.isSecond.toString()];
            }
            if(matchingNum.includes(parseInt(this.isFirst,10))){
                this.matched = this.entries[this.isFirst - 1][this.isFirst.toString()];
            }
        },
    }
}
</script>

<style scoped>
.open-button{
    position: absolute;
    top: 10px;
    right: 120px;
}
.groupName{
    font-size: 30px;
}
</style>